import { pickField } from "@/utility/fclReportFieldUtils";
import {
    clipText,
    dateReportCol,
    fileRefLinkCell,
    pickSort,
    reportCol,
} from "./importReportColumnUtils";

const formatOriginDisplay = (row) => {
    const origin = pickField(row, ["origin", "Origin"]);
    const customized = pickField(row, ["originCustomized", "OriginCustomized"]);
    const code = pickField(row, ["originCode", "OriginCode"]);

    if (origin && /\[[^\]]+\]/.test(origin)) return origin;
    if (customized && code && customized !== code) return `${customized} [${code}]`;
    if (origin && code) return `${origin} [${code}]`;
    return customized || origin || "";
};

export const IMPORT_ETA_STATUS_LIST_COLUMNS = [
    reportCol({
        key: "billofLadingNo",
        label: "Bill of lading No.",
        width: 155,
        sticky: "left",
        render: (row) =>
            fileRefLinkCell(
                pickField(row, [
                    "billofLadingNo",
                    "BillofLadingNo",
                    "billOfLadingNo",
                    "BillOfLadingNo",
                ])
            ),
        getTooltip: (row) =>
            pickField(row, [
                "billofLadingNo",
                "BillofLadingNo",
                "billOfLadingNo",
                "BillOfLadingNo",
            ]) || "",
        sortValue: (row) =>
            pickSort(row, ["billofLadingNo", "BillofLadingNo", "billOfLadingNo", "BillOfLadingNo"]),
    }),
    reportCol({
        key: "poNumber",
        label: "PO Number",
        width: 115,
        render: (row) => clipText(pickField(row, ["poNumber", "PoNumber", "PONumber"])),
        sortValue: (row) => pickSort(row, ["poNumber", "PoNumber", "PONumber"]),
    }),
    reportCol({
        key: "product",
        label: "Product",
        width: 140,
        render: (row) => {
            const v = pickField(row, [
                "pruduct",
                "Pruduct",
                "product",
                "Product",
                "packageType",
                "PackageType",
            ]);
            if (!v) return clipText("");
            return clipText(String(v).toUpperCase(), "font-medium uppercase tracking-wide");
        },
        sortValue: (row) =>
            pickSort(row, ["pruduct", "Pruduct", "product", "Product", "packageType", "PackageType"]),
    }),
    reportCol({
        key: "rpcRefNo",
        label: "R.P.C. REF No.",
        width: 145,
        render: (row) =>
            clipText(
                pickField(row, ["rpcRefNo", "RpcRefNo", "RPCRefNo"]),
                "font-mono text-[12px]"
            ),
        sortValue: (row) => pickSort(row, ["rpcRefNo", "RpcRefNo", "RPCRefNo"]),
    }),
    dateReportCol({
        key: "salingDate",
        label: "Sailing Date",
        width: 175,
        fieldKeys: ["salingDate", "SalingDate", "sailingDate", "SailingDate", "etd", "ETD"],
    }),
    reportCol({
        key: "origin",
        label: "Origin",
        width: 220,
        render: (row) => clipText(formatOriginDisplay(row)),
        getTooltip: (row) => formatOriginDisplay(row),
        sortValue: (row) => formatOriginDisplay(row).toLowerCase(),
    }),
    reportCol({
        key: "bookingNumber",
        label: "Booking Number",
        width: 135,
        render: (row) =>
            clipText(
                pickField(row, ["bookingNumber", "BookingNumber", "bookingNo", "BookingNo"]),
                "font-mono text-[12px]"
            ),
        sortValue: (row) => pickSort(row, ["bookingNumber", "BookingNumber", "bookingNo", "BookingNo"]),
    }),
    reportCol({
        key: "containerNo",
        label: "Container No.",
        width: 145,
        render: (row) =>
            clipText(
                pickField(row, ["containerNo", "ContainerNo", "containerNumber", "ContainerNumber"]),
                "font-mono text-[12px] font-medium"
            ),
        sortValue: (row) =>
            pickSort(row, ["containerNo", "ContainerNo", "containerNumber", "ContainerNumber"]),
    }),
    dateReportCol({
        key: "etaDestinationPort",
        label: "E.T.A. Destination Port",
        width: 175,
        fieldKeys: [
            "etaDestinationPort",
            "EtaDestinationPort",
            "ETADestinationPort",
            "podeta",
            "PodEta",
        ],
    }),
    dateReportCol({
        key: "doIssuedDate",
        label: "DO Issued Date",
        width: 165,
        fieldKeys: ["doIssuedDate", "DoIssuedDate", "DOIssuedDate"],
    }),
    dateReportCol({
        key: "etaDoor",
        label: "E.T.A. Door",
        width: 165,
        fieldKeys: ["etaDoor", "EtaDoor", "ETADoor"],
    }),
    dateReportCol({
        key: "deliveryAppointmentDate",
        label: "Delivery Appointment Date",
        width: 190,
        fieldKeys: ["deliveryAppointmentDate", "DeliveryAppointmentDate"],
    }),
];

/** @deprecated Use IMPORT_ETA_STATUS_LIST_COLUMNS */
export const IMPORT_ETA_STATUS_COLUMNS = IMPORT_ETA_STATUS_LIST_COLUMNS;
